import { NmsWizardStepModel } from "@nms-angular-toolkit/nms-wizard";
import { EndLink, EndTransmission, MuxDemux, Port, Slot, Transmission } from "../../../links.model";
import { Device } from "@nms-ng2/app/modules/device/device-backup/device-backup.models";

/** Representa os dados de AEnd/ZEnd */
export class EndPortLink  {
    endSlotId: string;
    endChassisNo: string;
    endPortNo: number;
    endResourceId: number;
    endMuxResourceId: number;
    muxDemux: boolean;
    endTransmission: Transmission;
    endPortModelId: string;
    endDeviceName: string;
    endDeviceModel: string;
    endDeviceModelCode: number;
    endDevice: Device;

    constructor(endSlotId: string = "", endChassisNo: string = "", endPortNo: number = 0, endResourceId: number = 0, // NOSONAR
                endMuxResourceId: number = null, muxDemux: boolean = false, endTransmission: Transmission = Transmission.NONE,
                endPortModelId: string = "", endDeviceName: string = "", endDeviceModel = "", endDeviceModelCode = 0) {
        this.endSlotId = endSlotId;
        this.endChassisNo = endChassisNo;
        this.endPortNo = endPortNo;
        this.endResourceId = endResourceId;
        this.endMuxResourceId = endMuxResourceId;
        this.muxDemux = muxDemux;
        this.endTransmission = endTransmission;
        this.endPortModelId = endPortModelId;
        this.endDeviceName = endDeviceName;
        this.endDeviceModel = endDeviceModel;
        this.endDeviceModelCode = endDeviceModelCode;
    }
}

/** Representa o modelo para criação de Links da aba de device */
export class DeviceLinkModel extends NmsWizardStepModel {
    linkId: number;
    aEndLink: EndPortLink;
    zEndLink: EndPortLink;
    isDwdm?: boolean;
}

/** Representa o modelo da requisição para geração de nome do link */
export class LinkEnds {
    linkId?: number;
    aEndLink: EndLink;
    zEndLink: EndLink;

    constructor(aEndLink: EndLink, zEndLink: EndLink, linkId?: number) {
        this.linkId = linkId;
        this.aEndLink = aEndLink;
        this.zEndLink = zEndLink;
    }
}

/** Classe responsável por organizar as informações principais de um End selecionado */
export class SelectedEnd {
    endDevice: Device;
    endSlotSelected: Slot;
    endPortSelected: Port;
    endMuxSelected: MuxDemux;
    endTransmission: EndTransmission<Transmission>;

    constructor(endDevice: Device = null, endSlotSelected: Slot = null, endPortSelected: Port = null,
            endMuxSelected: MuxDemux = null, endTransmission: EndTransmission<Transmission> = null) {
        this.endDevice = endDevice;
        this.endSlotSelected = endSlotSelected;
        this.endPortSelected = endPortSelected;
        this.endMuxSelected = endMuxSelected;
        this.endTransmission = endTransmission;
    }
}

/** Classe responsável por organizar os insumos principais da modal de links */
export class EndInputs {
    endSlots: Slot[];
    endPorts: Port[]
    endMuxes: MuxDemux[]
    endTransmissions: EndTransmission<Transmission>[];

    constructor(endSlots: Slot[] = [], endPorts: Port[] = [], endMuxes: MuxDemux[] = []) {
        this.endSlots = endSlots;
        this.endPorts = endPorts;
        this.endMuxes = endMuxes;
        this.endTransmissions = [
            { transmission: Transmission.TX, linked: false, label: "TX - OUT" },
            { transmission: Transmission.RX, linked: false, label: "RX - IN" }
        ];
    }
}
